import { Button } from "antd";
import { SPACE_HOME_HERO_LAYOUT } from "../Config";
import type { SpaceProfile } from "../SpaceType";
import { SpaceProfileHero } from "../components/SpaceProfileHero";

/** 空间信息 + 关注/订阅按钮 */
export function SpaceHomeInfoSection(props: {
  profile: SpaceProfile;
  isLoggedIn: boolean;
  favorStatus: 0 | 1;
  onLoginRequest: () => void;
  onFollow: () => void;
  onRequestUnfollow: () => void;
  onSubscribe: () => void;
}): JSX.Element {
  const {
    profile,
    isLoggedIn,
    favorStatus,
    onLoginRequest,
    onFollow,
    onRequestUnfollow,
    onSubscribe,
  } = props;
  const { followButton, subscribeButton } = SPACE_HOME_HERO_LAYOUT;

  return (
    <SpaceProfileHero
      profile={profile}
      actions={
        <div className="space-home-row space-home-row--actions">
          {isLoggedIn ? (
            favorStatus === 1 ? (
              <Button
                type="default"
                className="space-home-favor-btn"
                style={{ width: followButton.width }}
                onClick={onRequestUnfollow}
              >
                已关注
              </Button>
            ) : (
              <Button
                type="primary"
                className="space-home-favor-btn"
                style={{ width: followButton.width }}
                onClick={onFollow}
              >
                关注
              </Button>
            )
          ) : (
            <Button
              type="primary"
              className="space-home-favor-btn"
              style={{ width: followButton.width }}
              onClick={onLoginRequest}
            >
              关注
            </Button>
          )}
          <Button
            type="primary"
            className="space-home-subscribe-btn"
            style={{ width: subscribeButton.width }}
            onClick={onSubscribe}
          >
            订阅
          </Button>
        </div>
      }
    />
  );
}
